/**
 * PrefGroup — shared segmented-control used by both AI persona workspaces
 * (Kimani in AiAssistant.jsx, Obondo in ObondoChatPanel.jsx) for the
 * language / output-channel / depth preference toggles.
 */
export default function PrefGroup({ label, value, options, onChange, testIdPrefix, icon: HeadIcon }) {
    return (
        <div className="inline-flex items-center gap-2 border border-border rounded-md p-1 bg-card flex-wrap">
            <span className="text-[10px] uppercase font-bold tracking-widest text-muted-foreground pl-2 inline-flex items-center gap-1">
                {HeadIcon && <HeadIcon className="w-3 h-3" />} {label}
            </span>
            {options.map((o) => {
                const active = o.key === value;
                const Icon = o.Icon;
                return (
                    <button
                        key={o.key}
                        type="button"
                        onClick={() => onChange(o.key)}
                        data-testid={`${testIdPrefix}-${o.key}`}
                        className={`text-xs px-2.5 py-1 rounded inline-flex items-center gap-1 transition-colors ${
                            active
                                ? "bg-primary text-primary-foreground font-semibold"
                                : "text-muted-foreground hover:text-foreground"
                        }`}
                        aria-pressed={active}
                    >
                        {Icon && <Icon className="w-3.5 h-3.5" />} {o.label}
                    </button>
                );
            })}
        </div>
    );
}
